import { render } from "./Cabecalho.vue?vue&type=template&id=3c9b9726&scoped=true"
import script from "./Cabecalho.vue?vue&type=script&lang=js"
export * from "./Cabecalho.vue?vue&type=script&lang=js"

import "./Cabecalho.vue?vue&type=style&index=0&id=3c9b9726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9b9726"]])

export default __exports__